import { Select, MenuItem, makeStyles } from "@material-ui/core";
import clsx from "clsx";

const calendarProviders = [
  {
    name: "Google",
    url: "https://calendar.google.com/calendar/render?action=TEMPLATE",
    title: "text",
    description: "details",
    datetime: "dates=[start]/[end]",
    location: "location",
  },
  {
    name: "Outlook",
    url: "https://outlook.live.com/calendar/0/deeplink/compose?rru=addevent&path=%2Fcalendar%2Faction%2Fcompose",
    title: "subject",
    description: "body",
    datetime: "enddt=[end]&startdt=[start]",
    location: "location",
  },
  {
    name: "Yahoo",
    url: "https://calendar.yahoo.com/?v=60",
    title: "title",
    description: "desc",
    datetime: "st=[start]&et=[end]",
    location: "in_loc",
  },
];

interface SelectCalendarProviderProps {
  itemClassName: string;
}

const useStyles = makeStyles(() => ({
  hidenItem: {
    display: "none",
  },
  title: {
    display: "flex",
    alignItems: "center",
    fontWeight: 500,
    border: "none",
    "&.MuiInput-underline:hover:not(.Mui-disabled):before": {
      border: "none",
    },
    "&.MuiInput-underline:before": {
      border: "none",
    },
    "&.MuiInput-underline:after": {
      border: "none",
    },
  },
}));

const formatedDatetime = (datetime: Date, provider: string) => {
  switch (provider) {
    case "Google" || "Yahoo":
      return datetime.toISOString().replaceAll("-", "").replaceAll(":", "");
    default:
      return datetime.toISOString();
  }
};

const useToCalendarButtons = (params) => {
  const handleSelectChange = (e) => {
    const provider = calendarProviders.find(
      (prov) => prov.name === e.target.value
    );

    let fullUrl = provider.url;
    for (const param in provider) {
      if (!["name", "url", "datetime"].includes(param))
        fullUrl += `&${provider[param]}=${params[param] || "1:1 meeting"}`;
      else if (param === "datetime") {
        const endDateTime = new Date(
          new Date(params.start.toISOString()).setMinutes(
            params.start.getMinutes() + 30
          )
        );

        fullUrl += `&${provider[param]
          .replace("[start]", formatedDatetime(params.start, provider.name))
          .replace("[end]", formatedDatetime(endDateTime, provider.name))}`;
      }
    }

    window.open(fullUrl, "_blank", "noopener,noreferrer");
  };

  const SelectCalendarProvider = ({
    itemClassName,
  }: SelectCalendarProviderProps) => {
    const classes = useStyles();
    return (
      <Select
        onChange={handleSelectChange}
        className={clsx(itemClassName, classes.title)}
        value={0}
      >
        <MenuItem className={classes.hidenItem} value={0}>
          Add to Calendar
        </MenuItem>
        {calendarProviders.map((provider) => (
          <MenuItem key={provider.name} value={provider.name}>
            {provider.name}
          </MenuItem>
        ))}
      </Select>
    );
  };

  return {
    SelectCalendarProvider,
  };
};

export default useToCalendarButtons;
